<template>

    <div class="section-number-favourite">
        <h1 v-if="title" class="section-number-favourite__title">
            {{ title }}
        </h1>
        <div v-if="isPast" class="section-number-favourite__item-desktop__past">
            <div class="section-number-favourite__list-ball">
                <div
                    :class="`section-number-favourite__item-ball ${renderClass(
                        number,
                        index
                    )}`"
                    v-for="(number, index) in balls"
                    :key="index"
                >
                    <div class="section-number-favourite__box-ball">
                        <span class="section-number-favourite__number">{{
                            renderNumber(number)
                        }}</span>
                    </div>
                </div>
                <img
                    v-if="isShowIconArrow"
                    class="section-number-favourite__icon-show-ball"
                    src="@/assets/images/common/arrow-right-gray.png"
                    alt="random-numbers"
                    @click="$emit('onClickIconArrow', indexItem)"
                />
            </div>
            <div class="section-number-favourite__item-desktop__past__des">
                <div
                    class="section-number-favourite__item-desktop__past__des__raffle"
                >
                    <label class="t-transform-cap">{{
                        getTranslatedText("raffle id")
                    }}</label>
                    {{ raffle_id || getTranslatedText("Pending Generation")}}
                </div>
                <div
                    class="section-number-favourite__item-desktop__past__des__date"
                >
                    {{ getTranslatedText('draw date') }}: {{ dateBall }}
                </div>
            </div>
        </div>
        <div v-if="!isPast" class="section-number-favourite__item-desktop">
            <div class="section-number-favourite__list-ball__text">
                <div class="section-number-favourite__title__desktop">
                    {{ title }}
                </div>
            </div>
            <div class="section-number-favourite__list-ball">
                <div
                    :class="`section-number-favourite__item-ball ${renderClass(
                        number,
                        index
                    )}`"
                    v-for="(number, index) in balls"
                    :key="index"
                >
                    <div class="section-number-favourite__box-ball">
                        <span class="section-number-favourite__number">{{
                            renderNumber(number)
                        }}</span>
                    </div>
                </div>
                <img
                    v-if="isShowIconArrow"
                    class="section-number-favourite__icon-show-ball"
                    src="@/assets/images/common/arrow-right-gray.png"
                    alt="random-numbers"
                    @click="$emit('onClickIconArrow', indexItem)"
                />
            </div>
        </div>
        <div
            class="section-number-favourite__list-ball hide-desktop"
            @click="$emit('onClickIconArrow', indexItem)"
        >
            <div
                :class="`section-number-favourite__item-ball ${renderClass(
                    number,
                    index
                )}`"
                v-for="(number, index) in balls"
                :key="index"
            >
                <div class="section-number-favourite__box-ball">
                    <span class="section-number-favourite__number">{{
                        renderNumber(number)
                    }}</span>
                </div>
            </div>
            <img
                v-if="isShowIconArrow"
                class="section-number-favourite__icon-show-ball"
                :class="{ isRtl: $store.state.isRtl }"
                src="@/assets/images/common/arrow-right-gray.png"
                alt="random-numbers"
            />
        </div>
        <template v-if="dateBall">
            <p class="section-number-favourite__date">{{ getTranslatedText('draw date') }}: {{ dateBall }}</p>
        </template>
            <div v-if="showDownload"
                
                class="section-number-favourite__download"
                :class="{ disable: !link_certificate }"
            >   
                <b-spinner v-if="isLoading" variant="success" />
                <div class="section-number-favourite__download__icon">
                    <img v-if="userInfo.phone !== '' && link_certificate" @click="!isLoading && downloadFileSendToLink(raffle_id, 'phone')" src="@/assets/images/common/icon-sms.png" />
                    <img  v-if="userInfo.email !== '' && link_certificate" @click="!isLoading && downloadFileSendToLink(raffle_id, 'email')" src="@/assets/images/common/icon-email.png" />
                </div>
                <div class="section-number-favourite__download__box-label" @click="link_certificate && !isLoading && downloadFile(link_certificate)">
                    <img v-if="link_certificate" src="@/assets/images/download.png" />
                    <div class="section-number-favourite__download__label t-transform-cap">
                        {{ link_certificate ? getTranslatedText("green certificate") : getTranslatedText('generating certificate') }}
                    </div>
                </div>
            </div>

        <template v-if="isAction">
            <div class="section-number-favourite__action">
                <b-button
                    class="section-number-favourite__button section-number-favourite__action_edit t-transform-cap"
                    @click="$emit('onClickEdit', indexItem)"
                    v-if="isShowEdit"
                >
                    <img
                        src="@/assets/images/common/edit.png"
                        alt="random-numbers"
                    />
                    {{ getTranslatedText("edit") }}
                </b-button>
                <b-button
                    class="section-number-favourite__button section-number-favourite__action_delete t-transform-cap"
                    @click="$emit('onClickDelete', indexItem)"
                    v-if="isShowDelete"
                >
                    <img
                        src="@/assets/images/common/trash.png"
                        alt="random-numbers"
                    />
                    {{ getTranslatedText("delete") }}
                </b-button>
            </div>
        </template>


    </div>
</template>
<script>
import { renderClassBall, renderLocaleNumber } from "../utils";

import languageMixin from "@/mixins/language/language-mixin";
import favouriteService from '@/services/favourite.service';

export default {
    mixins: [languageMixin],
    components: {
        // Toast,
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        raffle_id: {
            type: String,
            default: "",
        },
        isPast: {
            type: Boolean,
            default: false,
        },
        isDownload: {
            type: Boolean,
            default: false,
        },
        balls: {
            type: Array,
            default: () => null,
        },
        isAction: {
            type: Boolean,
            default: true,
        },
        indexItem: {
            type: Number,
            default: -1,
        },
        maxiumBlue: {
            type: Number,
            default: -1,
        },
        maxiumGreen: {
            type: Number,
            default: -1,
        },
        isShowEdit: {
            type: Boolean,
            default: true,
        },
        isShowDelete: {
            type: Boolean,
            default: true,
        },
        minimumBall: {
            type: Number,
            default: 0,
        },
        dateBall: {
            type: String,
            default: "",
        },
        isShowIconArrow: {
            type: Boolean,
            default: false,
        },
        link_certificate: {
            type: String,
            default: ''
        },
        showDownload: {
            type: Boolean,
            default: true
        },
        userInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            isLoading: false,
        };
    },

    methods: {
        renderClass(number, index) {
            return renderClassBall(
                number,
                index,
                this.minimumBall,
                this.maxiumBlue,
                this.maxiumGreen
            );
        },
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
        },

        downloadFile(url ) {
            this.isLoading = true
            window.open(url, "_blank")
            setTimeout(() => {
                this.isLoading = false
            }, 2000);
        },
       
        renderNumber(number) {
            return renderLocaleNumber(number);
        },

        async downloadFileSendToLink(code, type) {
            try {
                this.isLoading = true
                const resp = type === 'email' ? await favouriteService.downloadCertificateSendToMail(code) : await favouriteService.downloadCertificateSendToPhone(code)
                if(resp.status === 200) {
                    this.$emit(
                        "showToast",
                        this.getTranslatedText(resp.message),
                        "success"
                    );
                    this.isLoading = false
                } else {
                    this.$emit(
                        "showToast",
                        this.getTranslatedText(resp.message),
                        "error"
                    );
                    this.isLoading = false
                }
            } catch (error) {
                this.isLoading = false
                console.log(error)
            }
        }
    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/common/number-favourite/_number-favourite.scss"
/>
